import { RatesService } from '@API/financial-indicators/rates.service';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogicalGrowthComponentsModule } from '@app/logical-growth-components/logical-growth-components.module';
import { environment } from '@environments/environment';
import { LoaderComponent } from '@shared/UI/utilities-ui/loader/loader.component';
import { ComponentStatus } from '@utils/constants';

@Component({
  selector: 'rate-table',
  standalone: true,
  imports: [CommonModule, LoaderComponent, LogicalGrowthComponentsModule],
  templateUrl: './rate-table.component.html',
  styleUrls: ['./rate-table.component.scss']
})
export class RateTableComponent implements OnInit {

  public statusData = signal<ComponentStatus>('init');
  public superMayorLink = environment.superMayorLink;

  private readonly _rateService = inject(RatesService);
  private readonly _destroyRef = inject(DestroyRef);

  get rateData() {
    return this._rateService.rateData();
  }

  ngOnInit(): void {
    if (this._rateService.rateData() !== null) {
      this.statusData.set('success');
      return;
    }
    this._fetchData();
  }

  private _fetchData(): void {
    this.statusData.set('loading');
    this._rateService.getCurrentMonthRate()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: () => this.statusData.set('success'),
        error: () => this.statusData.set('error'),
      });
  }
}
